import React from 'react'
import {UnsupportedBrowserModal} from '../modals/unsupported-browser'

export const UnexpectedError = () => <UnsupportedBrowserModal />
